import React,{useState,useMemo} from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  IconButton
} from '@material-ui/core';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import TextField from './TextField';
import { Typography } from '../';
import { Link } from 'react-router-dom';

const useInternalStyles = makeStyles((theme) => ({
  createButton: {
    height: '32px',
    padding: '4px'
  },
  editButton: {
    height: '32px',
    padding: '4px',
    marginRight: '8px'
  },
  previewButton: {
    height: '32px',
    padding: '4px',
    marginRight: '8px',
    flex: '0 0 auto',
    color: 'rgba(0, 0, 0, 0.54)',
    overflow: 'visible',
    display: 'block',
    float:'right'
    
  },
  componentVisibility:{
    display:''
  }
}));


const ResourceSpace = (props) => {
  const [option, setOption] = useState('rs_id');

  const handleChange = (event) => {
    setOption(event.target.value);
  };

  const useStyles = useMemo(() => {
    return makeStyles((theme) => (props.styles));
  }, [props.styles])

  const classes = useStyles();
  const internalClasses = useInternalStyles();
  const documentUrl = props.viewonclick ? props.viewonclick(): null;
  // second aditional option
  //const documentUrl2 = props.documentsDomain + props.value;// optio
 //console.log("props in resource control:  ",props.documentsDomain)

  return (
    <FormControl className={classes.formControl} component="fieldset" margin={props.margin}>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <Typography variant="h6">{props.label}</Typography>
        <div>
          {
            props.editBtnText && props.createDatasheet && props.editDatasheet && (
              <Tooltip title={props.editBtnText} arrow placement="top" className={internalClasses.componentVisibility}>
                <IconButton
                  classes={{root: internalClasses.editButton}}
                  aria-label="delete"
                  onClick={props.editonclick}
                >
                  <EditIcon/>
                </IconButton>
              </Tooltip>
            )
          }
          {
            props.createBtnText && props.createDatasheet && (
              <Tooltip title={props.createBtnText} arrow placement="top" className={internalClasses.componentVisibility}>
                <IconButton
                  classes={{root: internalClasses.createButton}}
                  aria-label="delete"
                  onClick={props.createonclick}
                >
                  <BorderAllIcon/>
                </IconButton>
              </Tooltip>
            )
          }
          {/* my code 17.08.2021*/}
          {
           
           documentUrl && (
            <Tooltip title={props.previewDocText} arrow placement="top">
            <Link
              to={{pathname: documentUrl}}
              className={internalClasses.previewButton}
              aria-label="delete"
              target="_blank"
            >
              <VisibilityIcon/>
            </Link>
            
          </Tooltip>
          //   <Tooltip title={props.previewDocText} arrow placement="top">
          //   <IconButton
          //     classes={{root: internalClasses.previewButton}}
          //     aria-label="delete"
          //     onClick={props.viewonclick}
          //   >
          //     <VisibilityIcon/>
          //   </IconButton>
          // </Tooltip>
        
            )
          }
        </div>
      </div>
      <RadioGroup
        aria-label="rs_id"
        name="rs_id"
        value={option}
        onChange={handleChange}
      >
        <FormControlLabel
          value="upload"
          control={<Radio />}
          classes={{root: classes.formControlLabelRoot}}
          disabled={props.disabled}
          label={
            <TextField
              label="upload"
              margin="dense"
              disabled={option === 'rs_id' || props.disabled}
            />
          }
        />
        <FormControlLabel
          value="rs_id"
          control={<Radio />}
          classes={{root: classes.formControlLabelRoot}}
          disabled={props.disabled}
          label={
            <TextField
              id={props.id}
              name={props.name}
              value={props.value}
              onChange={props.onChange}
              label="ResourceSpace ID"
              margin="dense"
              disabled={option === 'upload' || props.disabled}
            />
          }
        />
      </RadioGroup>
    </FormControl>
  );
};

ResourceSpace.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.any,
  onChange: PropTypes.func,
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
};

export default ResourceSpace;
